<template>
  <v-app>
    <div v-if="$vuetify.breakpoint.mdAndUp">
      <AuthBar />
      <SearchBar />
      <CategoryBar />
    </div>
    <MobileAppBar v-else @menu-click="isDrawerShow = !isDrawerShow" />

    <v-navigation-drawer v-model="isDrawerShow" app right v-if="!$vuetify.breakpoint.mdAndUp" :width="$vuetify.breakpoint.xs ? '80%' : '60%'">
      <MobileDrawer @close="isDrawerShow = false" />
    </v-navigation-drawer>
    <v-main>
      <v-container
        class="pa-0"
        :class="{
          'pt-12': !$vuetify.breakpoint.mdAndUp
        }"
        fluid
      >
        <transition name="scroll-y-transition">
          <router-view></router-view>
        </transition>
      </v-container>
      <app-dialog v-model="isLoginDialogShow" :title="$t('label.login')" @click:outside="closeLoginDialog">
        <login-form></login-form>
      </app-dialog>
      <ForgotPasswordDialog v-model="isForgotPasswordDialogShow" @login="openLoginDialog" />
      <SignUpDialog v-model="isSignUpDialogShow" />
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import { mapActions } from 'vuex'
import LoginForm from '@/components/authentication/LoginForm.vue'
import ForgotPasswordDialog from '@/components/authentication/ForgotPasswordDialog.vue'

// import AdvertisementColumn from '@/components/navbars/AdvertisementColumn.vue'
// import NavDrawer from "@/components/navbarsvDrawer.vue";
import AuthBar from '@/components/navbars/AuthBar'
import SearchBar from '@/components/navbars/SearchBar.vue'
import CategoryBar from '@/components/navbars/CategoryBar.vue'
import MobileAppBar from '@/components/navbars/MobileAppBar.vue'
import MobileDrawer from '@/components/navbars/MobileDrawer.vue'
import Footer from '@/components/Footer.vue'
import SignUpDialog from '../authentication/SignUpDialog.vue'

export default {
  name: 'Layout',
  components: {
    LoginForm,
    ForgotPasswordDialog,
    // AdvertisementColumn,
    AuthBar,
    SearchBar,
    CategoryBar,
    MobileAppBar,
    MobileDrawer,
    Footer,
    SignUpDialog
  },
  mounted() {
    this.$root.$app = this
    if (this.$route.query.referralCode || this.$route.hash === '#signup') {
      this.logoutAction()
      this.openSignUpDialog()
    }
  },
  data() {
    return {
      showAdvert: true,
      isLoginDialogShow: false,
      isForgotPasswordDialogShow: false,
      isSignUpDialogShow: false,
      isDrawerShow: false,
      group: null
    }
  },
  watch: {
    group() {
      this.isDrawerShow = false
    }
  },
  methods: {
    ...mapActions('auth', { logoutAction: 'logout' }),
    openLoginDialog() {
      this.closeAllDialogs()
      this.isLoginDialogShow = true
    },
    closeLoginDialog() {
      this.isLoginDialogShow = false
    },
    openForgotPasswordDialog() {
      this.closeAllDialogs()
      this.isForgotPasswordDialogShow = true
    },
    openSignUpDialog() {
      this.closeAllDialogs()
      this.isSignUpDialogShow = true
    },
    closeAllDialogs() {
      this.isDrawerShow = false
      this.isLoginDialogShow = false
      this.isForgotPasswordDialogShow = false
      this.isSignUpDialogShow = false
    }
  }
}
</script>
